import {
  ChangeDetectionStrategy,
  Component,
  InputSignal,
  OutputEmitterRef,
  Signal,
  computed,
  input,
  output,
} from '@angular/core';

import { FilterSelectionOption, MultiSelectionGroupComponent, SearchFieldComponent } from '@core/ui';
import { IndustryCatalogFilter, IndustryCatalogTaskFilter } from '@mp/content-manager/industriekataloge/data-access';

import { CATALOG_OPEN_TASKS_FILTER_OPTIONS } from './catalog-open-tasks-filter-options';

@Component({
  selector: 'mp-industriekataloge-filter-area',
  templateUrl: './industriekataloge-filter-area.component.html',
  styleUrl: './industriekataloge-filter-area.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SearchFieldComponent, MultiSelectionGroupComponent],
})
export class IndustriekatalogeFilterAreaComponent {
  readonly searchTerm: InputSignal<string> = input<string>('');

  readonly selectedOpenTasks: InputSignal<IndustryCatalogTaskFilter[]> = input<IndustryCatalogTaskFilter[]>([]);

  readonly selectedDataSources: InputSignal<string[]> = input<string[]>([]);

  readonly dataSources: InputSignal<string[]> = input<string[]>([]);

  readonly filterChanges: OutputEmitterRef<Partial<IndustryCatalogFilter>> = output<Partial<IndustryCatalogFilter>>();
  readonly searchTermChanged: OutputEmitterRef<string> = output<string>();

  protected readonly currentFilter: Signal<Partial<IndustryCatalogFilter>> = computed(() => ({
    openTasks: this.selectedOpenTasks(),
    dataSources: this.selectedDataSources(),
  }));

  protected readonly dataSourceFilterOptions: Signal<FilterSelectionOption<string>[]> = computed(() =>
    this.dataSources().map((dataSource) => ({ value: dataSource, label: dataSource })),
  );

  readonly catalogOpenTasksFilterOptions: FilterSelectionOption<IndustryCatalogTaskFilter>[] =
    CATALOG_OPEN_TASKS_FILTER_OPTIONS;

  handleFilterChanges(filterChanges: Partial<IndustryCatalogFilter>): void {
    this.filterChanges.emit({ ...this.currentFilter(), ...filterChanges });
  }

  onSearchbarSubmitted(term: string): void {
    this.searchTermChanged.emit(term);
  }
}
